import { useQuery } from '@tanstack/react-query';
import { useAppState } from './AppState.js';
import { useRequiredLeagueId, useResolvedActiveSeason } from './hooks.js';

export function MatchDaysPage() {
    const leagueId = useRequiredLeagueId();
    const { client } = useAppState();
    const { season } = useResolvedActiveSeason(leagueId);

    const matchDaysQuery = useQuery({
        queryKey: ['matchDays', leagueId, season?.id ?? null],
        enabled: Boolean(client && season),
        queryFn: async () => (await client!.getMatchDays(leagueId, season!.id)).matchDays,
    });

    const matchDays = matchDaysQuery.data ?? [];

    return <div>Match Days List ({matchDays.length})</div>;
}   